import {Menu} from './menu';

export const items: Menu[] = [
  {id: 1, path: 'edit', description: 'profile', icon: 'lock'},
  {id: 2, path: 'address', description: 'adressedes', icon: 'map'},
  {id: 3, path: 'cards', description: 'cards-and-payments', icon: 'card'},
  // {id: 4, path: 'referral', description: 'invitation-code', icon: 'label'},
  {id: 6, path: 'promo', description: 'promo-code', icon: 'percent'},
  {id: 7, path: 'wallet-points', description: 'my-points', icon: 'gel'},
  {id: 8, path: 'authorization', description: 'autorisation', icon: 'clip'},
  {id: 9, path: 'insurance', description: 'insurance-cards', icon: 'shield'},
  // {id: 10, path: 'delete', description: 'deactivation', icon: 'times-circle'},
  {id: 11, path: 'sms-language', description: 'sms-language', icon: 'times-circle'},
  {id: 12, path: 'terms-and-conditions', description: 'terms-and-conditions', icon: 'shield'}
];

export const doctorItems: Menu[] = [
  {id: 1, path: 'edit', description: 'changePassword', icon: 'lock'},
  {id: 2, path: 'doctor-edit', description: 'edit-profile', icon: 'doctor'},
  {id: 3, path: 'doctor-services', description: 'my-services', icon: 'cabinet'},
  // {id: 4, path: 'referral-doctor', description: 'რეფერალები', icon: 'label'},
  {id: 5, path: 'cards', description: 'cards', icon: 'card'},
  {id: 6, path: 'doctor-iban', description: 'information-on-payments', icon: 'doctor'},
  {id: 11, path: 'delete', description: 'deactivation', icon: 'times-circle'},
];
